import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'distancia'
})
export class DistanciaPipe implements PipeTransform {
  transform(value: any): any {
    if( value >= 1000 ){
      return value / 1000 + "Km";
    }else{
      return value + "m";
    }
  }
}



// WEBPACK FOOTER //
// C:/xampp/htdocs/service_tracking/web/service_tracking/src/app/pipes/distancia.pipe.ts